class ChromeclayTheme {
  constructor() {
    this.drawer = document.querySelector('[data-cart-drawer]');
    this.bindEvents();
    document.querySelectorAll('[data-variant-select]').forEach((selector) => this.updateVariant(selector));
  }

  bindEvents() {
    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-cart-open]');
      const closeButton = event.target.closest('[data-cart-close]');
      if (openButton) { event.preventDefault(); this.openDrawer(); }
      if (closeButton) { event.preventDefault(); this.closeDrawer(); }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeDrawer();
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-product-form]');
      if (!form) return;
      event.preventDefault();
      this.addToCart(form);
    });

    document.addEventListener('change', (event) => {
      const selector = event.target.closest('[data-variant-select]');
      if (!selector) return;
      this.updateVariant(selector);
    });
  }

  updateVariant(selector) {
    const selected = selector.options[selector.selectedIndex];
    const productSection = selector.closest('.product-main');
    const form = selector.closest('[data-product-form]');
    const button = form?.querySelector('[name="add"]');
    const price = productSection?.querySelector('[data-product-price]');

    if (button) {
      button.disabled = selected.disabled;
      button.textContent = selected.disabled ? 'Sold out' : button.dataset.addLabel;
    }
    if (price && selected.dataset.price) price.textContent = selected.dataset.price;

    const gallery = productSection?.querySelector('[data-product-gallery]');
    const mediaId = selected.dataset.mediaId;
    if (!gallery || !mediaId) return;

    const selectedMedia = gallery.querySelector(`[data-media-id="${mediaId}"]`);
    if (selectedMedia) {
      if (gallery.firstElementChild !== selectedMedia) gallery.insertBefore(selectedMedia, gallery.firstElementChild);
      return;
    }

    if (selected.dataset.mediaUrl) {
      const media = document.createElement('div');
      const image = document.createElement('img');
      media.className = 'product-media';
      media.dataset.mediaId = mediaId;
      image.src = selected.dataset.mediaUrl;
      image.alt = selected.dataset.mediaAlt || '';
      image.loading = 'eager';
      image.decoding = 'async';
      media.appendChild(image);
      gallery.insertBefore(media, gallery.firstElementChild);
    }
  }

  async addToCart(form) {
    const button = form.querySelector('[name="add"]');
    const originalText = button?.textContent;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error((await response.json()).description || 'Unable to add this item.');
      await this.refreshDrawer();
      this.openDrawer();
    } catch (error) {
      const errorBox = form.querySelector('[data-product-error]');
      if (errorBox) { errorBox.hidden = false; errorBox.textContent = error.message; }
    } finally {
      if (button) { button.disabled = false; button.textContent = originalText; }
    }
  }

  async refreshDrawer() {
    const response = await fetch(window.Shopify.routes.root + '?section_id=cart-drawer');
    const html = await response.text();
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
    if (next && this.drawer) {
      this.drawer.replaceWith(next);
      this.drawer = next;
      document.querySelectorAll('.cart-count[data-cart-count]').forEach((node) => {
        node.textContent = next.dataset.cartCount;
        node.hidden = Number(next.dataset.cartCount) === 0;
      });
    }
  }

  openDrawer() {
    if (!this.drawer) return;
    this.drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    this.drawer.querySelector('[data-cart-close]')?.focus();
  }

  closeDrawer() {
    if (!this.drawer) return;
    this.drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }
}

document.addEventListener('DOMContentLoaded', () => new ChromeclayTheme());
